import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// The API (and its cookies) live on REACT_APP_BACKEND_URL's host. If the site is opened on another
// alias of it (e.g. www.), move the visitor to that host so all requests stay same-origin.
const apiHost = new URL(process.env.REACT_APP_BACKEND_URL).host;
const redirecting = window.location.host !== apiHost && window.location.host === `www.${apiHost}`;
if (redirecting) {
  window.location.replace(`${window.location.protocol}//${apiHost}${window.location.pathname}${window.location.search}${window.location.hash}`);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
if (!redirecting) root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
